import React, { useEffect } from "react";

import ViewAppBar from "../views/ViewAppBar";

import ViewFooter from "../views/ViewFooter";
import ContatoZap from "../components/ContatoZap";


import FormSection from "../views/FormSection";

import { useLocation } from "react-router-dom";
import ViewComprar from "../views/ViewComprar";



const Compra: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash === "#formulario") {
      const target = document.querySelector(location.hash);
      if (target) {
        setTimeout(() => {
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 300);
      }
    }
  }, [location]);
  
  
  return(

  
  <>
    <ContatoZap />
    <div>
      <ViewAppBar />

     
      <ViewComprar/>  
    
    
      <FormSection tipo="compra" />
      

      <ViewFooter />
    </div>
  </>
)};
export default Compra;
